import { LitElement, html, css, classMap } from '@hh/global.js'

class HHStickyAtc extends LitElement {
  static properties = {
    _show: {
      type: Boolean,
      state: true,
    },
    _intersectFooter: {
      type: Boolean,
      state: true,
    },
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.mainProductForm =
      this.closest('.js-main-product')?.querySelector('hh-product-form')
    this.mainProductForm.addEventListener(
      'productAdded',
      this.onSubmitSuccess.bind(this)
    )
    this.atcButton.addEventListener('click', this.onAddToCartClick.bind(this))

    const productCtaWrapper = document.querySelector('.js-product-container')
    this.observer = new IntersectionObserver(this.onIntersection.bind(this), {
      threshold: 0,
      rootMargin: '-400px 0px 0px 0px'
    })

    this.observer.observe(productCtaWrapper)

    const footer = document.querySelector('footer')
    this.footerObserver = new IntersectionObserver(this.onFooterIntersection.bind(this), {
      threshold: 0,
      rootMargin: "100px 0px 0px 0px"
    })

    this.footerObserver.observe(footer)
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.mainProductForm.removeEventListener(
      'productAdded',
      this.onSubmitSuccess
    )
    this.observer?.disconnect()
    this.footerObserver?.disconnect()
  }

  onAddToCartClick(e) {
    e.preventDefault()
    const { target } = e
    this.mainProductForm.dispatchEvent(
      new CustomEvent('addToCart', { bubbles: true })
    )

    target.setAttribute('disabled', true)
    target.classList.add('loading')
  }

  onSubmitSuccess() {
    if (this.atcButton.hasAttribute('disabled')) {
      this.atcButton.removeAttribute('disabled')
      this.atcButton.classList.remove('loading')
    }
  }

  onIntersection([entry]) {
    const { isIntersecting } = entry
    this._show = !isIntersecting
  }

  onFooterIntersection([entry]) {
    const { isIntersecting } = entry
    this._intersectFooter = isIntersecting
  }

  get atcButton() {
    return this.querySelector('.js-sticky-atc') ?? null
  }

  render() {
    return html`
      <section
        class=${classMap({
          container: true,
          show: this._show && !this._intersectFooter,
          motion: true,
        })}
      >
        <slot></slot>
      </section>
    `
  }

  static styles = css`
    :host *,
    :host *::before,
    :host *::after {
      box-sizing: border-box;
    }

    .container {
      padding: var(--hh-space-xs);
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      z-index: 2;
      transform: translate3d(0, 100%, 0);
      transition: transform var(--hh-duration-long) ease;
      will-change: transform;
    }

    @media (min-width: 750px) {
      .container {
        width: max(660px, 45vw);
        left: auto;
        right: var(--hh-space-xs);
        bottom: var(--hh-space-sm);
        transform: translate3d(calc(100% + 2rem), 0, 0);
      }
    }

    .container.show {
      transform: translate3d(0, 0, 0);
    }

    .hide {
      display: none;
    }

    @media (prefers-reduced-motion) {
      .motion,
      .motion * {
        animation: none !important;
        transition: none !important;
      }
    }
  `
}

customElements.define('hh-sticky-atc', HHStickyAtc)
